// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"q9-z"};